export default __webpack_public_path__ + "static/media/github-icon.2012dbb2.svg";